const stringHelpers = require('../../../common/components/stringhelpers');

module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.productgroup', {
            url: '/productgroup/{Id}?{name}&{productId:int}&{cardId:int}&{pageNumber:int}&{filters}&{sortby}',
            data: {
                analytics: [
                    '$state', function ($state) {
                        return `bws:web:plp:specials:${($state.params.Id).toLowerCase()}`;
                    }
                ],
                pageMetadata: [
                    '$state', 'PageMetadataService', 'ProductGroupService', function ($state, pageMetadataService, productGroupService) {
                        let result;
                        if ($state.params && $state.params.Id) {
                            const id = stringHelpers.toTitleCase($state.params.Id.replace(new RegExp('-', 'g'), ' '));
                            // returns the correct title when url contains product group ID
                            result = productGroupService.selectProductGroup(id).then((productGroup) => {
                                return pageMetadataService.getMetadata({ name: productGroup.Name });
                            });
                        } else {
                            result = {
                                title: 'Shop Product Group | BWS',
                                metaDescription: 'Shop Product Group'
                            };
                        }
                        return result;
                    }
                ],
                canonicalUrl: ['$state', 'ProductGroupService', 'PageMetadataService', function ($state, productGroupService, pageMetadataService) {
                    const id = stringHelpers.toTitleCase($state.params.Id.replace(new RegExp('-', 'g'), ' '));
                    // returns the correct canonicalUrl, in case product group Id is used.
                    return productGroupService.selectProductGroup(id).then((productGroup) => {
                        return pageMetadataService.getNormalizedCanonicalUrl($state.params.Id, productGroup.Url);
                    });
                }
                ],
                showBothPanelsInSmallFormat: true,
                noIndex: null
            },
            views: {
                'left-panel@': {
                    template: '<wow-filters-mobile></wow-filters-mobile>'
                },
                'center-panel@': {
                    template: '<bws-product-group></bws-product-group>'
                },
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                },
                '': {
                    template: '<oly-sticky-header-with-text ng-if="breakpointsService.isInSmallFormat" ng-show="showHeader"></oly-sticky-header-with-text>'
                },
                'aem-view@': {
                    template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
                }
            }
        });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/productgroups.js
 **/